var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34199 11.9998C5.34199 8.32281 8.32281 5.34199 11.9998 5.34199C15.6769 5.34199 18.6577 8.32281 18.6577 11.9998C18.6577 15.6769 15.6769 18.6577 11.9998 18.6577C8.32281 18.6577 5.34199 15.6769 5.34199 11.9998ZM11.9998 4.04199C7.60484 4.04199 4.04199 7.60484 4.04199 11.9998C4.04199 16.3948 7.60484 19.9577 11.9998 19.9577C16.3948 19.9577 19.9577 16.3948 19.9577 11.9998C19.9577 7.60484 16.3948 4.04199 11.9998 4.04199ZM8.79412 8.03821C8.53881 7.78585 8.12726 7.78825 7.8749 8.04357C7.62254 8.29889 7.62494 8.71044 7.88026 8.96279L14.5377 15.5431C14.793 15.7954 15.2046 15.793 15.4569 15.5377C15.7093 15.2824 15.7069 14.8708 15.4516 14.6185L8.79412 8.03821Z",
    fill: "#657D9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.8a39d502.svg";
export { ForwardRef as ReactComponent };